var _path, _ellipse, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaidSpeedometer = function SvgPlaidSpeedometer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0392 11.8955C23.0392 16.9637 18.9306 21.0723 13.8624 21.0723C8.79415 21.0723 4.68555 16.9637 4.68555 11.8955C4.68555 6.82729 8.79415 2.71869 13.8624 2.71869C18.9306 2.71869 23.0392 6.82729 23.0392 11.8955Z",
    stroke: "#1C4645"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8625,
    cy: 11.8957,
    rx: 1.24536,
    ry: 1.24536,
    fill: "#3D7C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9355 11.8847L18.4479 13.3791",
    stroke: "#3D7C54",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5468 11.8525C20.5468 8.10675 17.5103 5.07025 13.7646 5.07025C10.0189 5.07025 6.98242 8.10675 6.98242 11.8525C6.98242 13.9204 7.90791 15.7721 9.36729 17.0161M18.162 17.0161C18.3328 16.8705 18.4964 16.7165 18.652 16.5548C19.4109 15.7662 19.9808 14.7944 20.2887 13.7123",
    stroke: "#1C4645",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63086 0.427673V3.42047",
    stroke: "#FFBE00",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.91449H4.26153",
    stroke: "#FFBE00",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaidSpeedometer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plaid-speedometer.4a252a4dfa9c204ad1624cff79aba39f.svg";